(function() {
	'use strict';
	angular
	.module('gatewayApp')
	.factory('OTRSummaryView', OTRSummaryView);

	OTRSummaryView.$inject = ['$resource'];

	function OTRSummaryView ($resource) {
		var resourceUrl =  'api/otr-summary/:id';

		return $resource(resourceUrl, {}, {

			'getOTRSummaryReport':{          	 
				method: 'GET',
				params: {bankId : '@bankId',from : '@from', to: '@to',printorGenerateAfreshOption : '@printorGenerateAfreshOption'},  				
				url: 'api/otr-summary/get-otr-summary-details'
			},
			'exportOTRSummaryExcel':{
				method: 'POST',
				url: 'api/otr-summary/excel-download',
				responseType: 'arraybuffer',
				params: {freshOrPrintOption : '@freshOrPrintOption', bank : '@bank'},
				transformRequest: function (data) {
	                   	var copy = angular.copy(data);
	                   	
	                       return angular.toJson(copy);
	            },
				transformResponse: function(data, headers) {
					return {
						data: data,
						headers: headers
					};   
				}      
			},
			'downloadEInvoiceExcel':{
				method: 'POST',
				url: 'api/otr-summary/eInvoice-download',
				responseType: 'arraybuffer',
				params: {from : '@from', to: '@to',financialYearId : '@financialYearId'},
				transformRequest: function (data) {
	                   	var copy = angular.copy(data);
	                   	
	                       return angular.toJson(copy);
	            },
				transformResponse: function(data, headers) {
					return {
						data: data,
						headers: headers
					};   
				}      
			},
			'exportOTRSummaryCsv':{
				method: 'POST',
				url: 'api/otr-summary/csv-download',
				responseType: 'arraybuffer',
				params: {freshOrPrintOption : '@freshOrPrintOption', bank : '@bank'},
				transformRequest: function (data) {
                   	var copy = angular.copy(data);
                   	
                       return angular.toJson(copy);
            },
			transformResponse: function(data, headers) {
				return {
					data: data,
					headers: headers
				};   
			}         
			},
			'exportOTRSummaryPdf':{
				method: 'POST',
				url: 'api/otr-summary/pdf-download',
				responseType: 'arraybuffer',
				params: {freshOrPrintOption : '@freshOrPrintOption', bank : '@bank'},
				transformResponse: function(data, headers) {
					return {
						data: data,
						headers: headers
					};   
				}      
			}

		});
	}
})();
